import React from 'react';
import AnchorNavHorizontal from '../../platformui/AnchorNavHorizontal';
import { node, string, arrayOf, shape } from 'prop-types';

export default ({
  Links,
  anchorHeading,
  currentActiveId,
  currentTop,
  items,
  translations,
}) => {
  return (
    <AnchorNavHorizontal
      Links={Links}
      anchorHeading={anchorHeading}
      currentActiveId={currentActiveId}
      currentTop={currentTop}
      items={items}
      translations={translations}
    />
  );
};

AnchorNavHorizontal.propTypes = {
  currentActiveId: string,
  anchorHeading: string,
  currentTop: node,
  Links: arrayOf(
    shape({
      Id: string,
      Name: node,
    })
  ),
  items: arrayOf(
    shape({
      Id: string,
      Name: node,
    })
  ),
  translations: shape({
    anchorheading: string,
    anchorheadingmobile: string,
  })
};
